module.exports = __webpack_public_path__ + "img/32.62e8f60c.jpg";